export const isDateLike = (v) => {
    if (v == null)
        return false;
    if (typeof v !== 'object')
        return false;
    if (v instanceof Date ||
        Object.prototype.toString.call(v) === '[object Date]') {
        return 'toISOString' in v;
    }
    return false;
};
export const isTemporalInstantLike = (v) => {
    if (v == null)
        return false;
    if (typeof v !== 'object')
        return false;
    if (!('epochMilliseconds' in v))
        return false;
    try {
        if (typeof v.epochMilliseconds !== 'number')
            return false;
        if (isNaN(v.epochMilliseconds))
            return false;
        return true;
    }
    catch {
        return false;
    }
};
//# sourceMappingURL=date.js.map